export default __webpack_public_path__ + "static/media/Edit-icon.bbd7ab89.svg";